/**
 * Consolidated Header JavaScript
 * Combines functionality from header.js and section-header.js
 * Handles scroll behavior, search modal, mobile menu, and cart updates
 */

class Header {
  constructor() {
    this.header = document.querySelector('[data-header]');
    this.searchOpen = document.querySelector('[data-search-open]');
    this.mobileMenuOpen = document.querySelector('[data-mobile-menu-open]');
    this.isHomepage = document.body.classList.contains('template-index');

    if (this.header) {
      this.init();
    }
  }

  init() {
    this.setupScroll();
    this.setupSearch();
    this.setupMobileMenu();
    this.updateCartCount();
  }

  setupScroll() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
    // Check initial scroll position
    this.handleScroll();
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const threshold = 50; // Show background after 50px scroll

    if (scrollY > threshold) {
      this.header.classList.add('is-scrolled');
    } else {
      this.header.classList.remove('is-scrolled');
    }
  }

  setupSearch() {
    if (this.searchOpen) {
      this.searchOpen.addEventListener('click', () => {
        try {
          const searchModal = document.querySelector('[data-search-modal]');
          if (searchModal) {
            searchModal.classList.add('active');
            this.searchOpen.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
            // Focus input after modal opens
            const input = searchModal.querySelector('input');
            if (input) setTimeout(() => input.focus(), 100);
          }
        } catch (error) {
          console.error('Error opening search modal:', error);
        }
      });
    }
  }

  setupMobileMenu() {
    if (this.mobileMenuOpen) {
      this.mobileMenuOpen.addEventListener('click', () => {
        try {
          const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
          if (mobileMenuOverlay) {
            mobileMenuOverlay.classList.add('is-open');
            this.mobileMenuOpen.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
          }
        } catch (error) {
          console.error('Error opening mobile menu:', error);
        }
      });
    }

    // Close menu when clicking overlay
    document.addEventListener('click', (e) => {
      try {
        const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
        if (mobileMenuOverlay && e.target === mobileMenuOverlay) {
          mobileMenuOverlay.classList.remove('is-open');
          this.mobileMenuOpen.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      } catch (error) {
        console.error('Error closing mobile menu on overlay click:', error);
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      try {
        if (e.key === 'Escape') {
          const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
          if (mobileMenuOverlay && mobileMenuOverlay.classList.contains('is-open')) {
            mobileMenuOverlay.classList.remove('is-open');
            this.mobileMenuOpen.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
          }
        }
      } catch (error) {
        console.error('Error closing mobile menu on escape key:', error);
      }
    });
  }

  updateCartCount() {
    // Listen for cart updates
    document.addEventListener('cart:updated', (event) => {
      try {
        const countElement = document.querySelector('[data-cart-count]');
        if (countElement && event.detail?.cart) {
          countElement.textContent = event.detail.cart.item_count;
        }
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    });
  }

}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new Header());
} else {
  new Header();
}